
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import useAuth from '../../common/client/hooks/useAuth';
import ResetPasswordForm from '../../common/client/components/ResetPasswordForm';
import ResetPasswordRequestForm from '../../common/client/components/ResetPasswordRequestForm';
import IfComp from '../../common/client/components/IfComp';
import Text from '../../common/client/components/Text';
import AppPageStyle from '../../common/client/components/mysliveckyportal/AppPageStyle';

import useNavigationItems  from '../../hooks/useNavigationItems';

const classNames = mergeStyleSets({
    ResetPasswordPage: {
    },
    panel: {
        backgroundColor: '#ffffff',
        marginTop: 64,
        marginBottom: 64,
        padding: 8,
        border: '1px solid #999999',
        width: 430
    },
    sendPanel: {
        paddingTop: 16
    }
});

const ResetPasswordPage = () => {

    const history = useHistory();
    const auth = useAuth();
    const { search } = useLocation();
    const navigationItems = useNavigationItems();

    const rpc = new URLSearchParams(search).get('rpc');

    const handleCancelClick = () => {
        history.push('/');
    }

    return (
        <AppPageStyle
            navigationItems={navigationItems}
        >
            <Stack className={classNames.ResetPasswordPage}>
                <Stack.Item className={classNames.panel} align="center">
                    <Text xxLarge>Obnova zapomenutého hesla</Text>
                    <IfComp cond={rpc}>
                        <ResetPasswordForm
                            rpc={rpc}
                            onCancelClick={handleCancelClick}
                        />
                    </IfComp>
                    <IfComp cond={!rpc}>
                        <IfComp cond={auth.resetPasswordRequestSend}>
                            <div className={classNames.sendPanel}>
                                <>Žádost o obnovu hesla byla odeslaná. </>
                                <>Dále pokračujte podle pokynů v e-mailu, který byl odeslán na Vaši e-mailovou adresu. </>
                            </div>
                        </IfComp>
                        <IfComp cond={!auth.resetPasswordRequestSend}>
                            <ResetPasswordRequestForm
                                onCancelClick={handleCancelClick}
                            />
                        </IfComp>
                    </IfComp>
                </Stack.Item>
            </Stack>
        </AppPageStyle>
    );
}

export default ResetPasswordPage;
